module.exports = __webpack_public_path__ + "32c53ffba59c2f14158f830d238418fc.pdf";